import { Outlet } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

import { PageTabs } from '../ui/page-tabs/page-tabs'
import { CASE_UPDATES_TAB_ITEMS, DOM_ID } from './constants'

export const DashboardCaseUpdatesLayout = () => {
  return (
    <>
      <div className={cn('mt-5', 'p-5', 'rounded-lg border border-border', 'shadow-sm')}>
        <PageTabs items={CASE_UPDATES_TAB_ITEMS} />

        <Outlet />
      </div>

      {/* This is portal root for pagination component in Case Update History page */}
      <div id={DOM_ID.caseUpdatesPaginationPortal} className={cn('mt-5')} />
    </>
  )
}
